import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'hooks/useCustomQuery';
import getCarriers from 'API/Carriers/getCarriers';

const useGetCarriers = (setTableData, gridRef, colDefs) => {
    const { currentScope } = useSelector((state) => state.login);

    const query = useQuery({
        queryKey: ['Carriers', currentScope],
        queryFn: () => getCarriers(currentScope),
        staleTime: 5 * 60 * 1000,
        retry: 2,
        refetchOnWindowFocus: false,
    });

    useEffect(() => {
        if (query.data) {
            setTableData({
                columns: colDefs,
                data: query.data,
            });

            gridRef?.current?.api?.applyColumnState({
                state: [{ colId: 'name', sort: 'asc' }],
            });
        }
    }, [query.data, setTableData, colDefs, gridRef]);

    return {
        ...query,
        refetch: query.refetch,
        isRefetching: query.isRefetching,
        isFetching: query.isFetching,
    };
};

export default useGetCarriers;
